import { z } from 'zod';
import { ApiClient } from '../lib/api';
import {
  Material,
  MaterialSchema,
  MaterialsList
} from '../models/material';
import { MaterialFormula, MaterialFormulaSchema } from '../models/material-formula';

export class MaterialService {
  private readonly api: ApiClient;

  constructor(baseURL: string, stage: string) {
    this.api = new ApiClient(`${baseURL}/${stage}/materials-service-${stage}`, stage);
  }


  async getMaterialsByWorkTypes(workTypes: string[]): Promise<Material[]> {
    return this.api.request(
      { 
        method: 'GET', 
        url: `/materials/product-types?services=${workTypes.join(',') || ''}` 
      },
      MaterialSchema.array()
    );
  }

  generateMaterialOrder(quoteId: number): Promise<{
    message: string,
    created: number[],
    updated: number[]
  }> {
    return this.api.request(
      { 
        method: 'POST', 
        url: `/materials/generate-order`, 
        data: { quoteId } 
      },
      z.object({
        message: z.string(),
        created: z.number().array(),
        updated: z.number().array()
      })
    );
  }

  async getAllMaterialFormulas(): Promise<MaterialFormula[]> {
    return this.api.request(
      {
        method: 'GET',
        url: `/materials/formulas`
      },
      MaterialFormulaSchema.array()
    );
  }

  async getMaterialOrdersByJobId(jobId: number): Promise<MaterialsList[]> {
    const response = await this.api.request(
      {
        method: 'GET',
        url: `/materials/orders/job/${jobId}`
      },
      z.array(z.any())
    );
    
    // Ensure required fields have default values
    return response.map(item => ({
      ...item,
      mlorderdelivfee: item.mlorderdelivfee ?? 0,
      mlordertot: item.mlordertot ?? 0,
      mlcredit: item.mlcredit ?? 0
    })) as MaterialsList[];
  }
}
